export enum FormOptions {
  NONE_APPLY = 'noneApply',
  AFFILIATED_BROKER = 'employedAffiliatedWithBrokerDealer',
  SHAREHOLDER_DIRECTOR = 'shareholderOrDirector',
  BACKUP_WITHHOLDING = 'subjectToBackupWithholding',
}

export type FormValues = Record<FormOptions, boolean>

export const initialValues: FormValues = {
  [FormOptions.NONE_APPLY]: true,
  [FormOptions.AFFILIATED_BROKER]: false,
  [FormOptions.SHAREHOLDER_DIRECTOR]: false,
  [FormOptions.BACKUP_WITHHOLDING]: false,
}

export const formRows = [
  {
    name: FormOptions.AFFILIATED_BROKER,
    labelKey: 'investor_questions.form.employed_affiliated_broker_dealer',
  },
  {
    name: FormOptions.BACKUP_WITHHOLDING,
    labelKey: 'investor_questions.form.backup_withholding',
  },
  {
    name: FormOptions.SHAREHOLDER_DIRECTOR,
    labelKey: 'investor_questions.form.shareholder_director',
  },
  {
    name: FormOptions.NONE_APPLY,
    labelKey: 'investor_questions.form.none_apply',
  },
]
